/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */


/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    clientId: process.env.REACT_APP_CLIENTID,
    authority: `https://login.microsoftonline.com/` + process.env.REACT_APP_TENNANT,
    tenantId: process.env.REACT_APP_TENNANT,
    scopes: ["User.Read"],

    auth: {
        clientId: process.env.REACT_APP_CLIENTID,
        authority: `https://login.microsoftonline.com/` + process.env.REACT_APP_TENNANT,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
    },


};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
export const graphImageConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"
};